import { createContext, useContext, useEffect, useState } from "react";

const LanguageContext = createContext({
    lang: "al",
    setLang: () => {},
    t: (k) => k,
});

export const LANGUAGES = [
    { code: "al", label: "AL", flag: "🇦🇱", name: "Shqip" },
    { code: "en", label: "EN", flag: "🇬🇧", name: "English" },
    { code: "it", label: "IT", flag: "🇮🇹", name: "Italiano" },
    { code: "de", label: "DE", flag: "🇩🇪", name: "Deutsch" },
];

const baseStrings = {
    al: {
        nav_home: "Kreu", nav_rooms: "Dhomat", nav_facilities: "Lehtësirat",
        nav_gallery: "Galeria", nav_contact: "Kontakti", nav_admin: "Admin", nav_faq: "FAQ", nav_blog: "Blog",
        book_now: "Rezervo Tani", whatsapp_book: "Rezervo në WhatsApp",
        wifi: "Wi-Fi Falas", restaurant: "Restorant", bar: "Bar", beach: "Plazh", parking: "Parking", market: "Market",
        featured_rooms: "Dhomat Tona", featured_rooms_sub: "Hapësira të dizajnuara për qetësi dhe pamje deti",
        view_all_rooms: "Shiko të gjitha dhomat", from_price: "Nga", per_night: "/ natë",
        explore_facilities: "Lehtësirat Tona", facilities_sub: "Gjithçka që ju nevojitet për një qëndrim të paharrueshëm",
        reviews_title: "Çfarë Thonë Mysafirët", reviews_sub: "Përvoja të vërteta nga mysafirët tanë të dashur",
        gallery_title: "Galeri", gallery_sub: "Shikoni një pjesë të botës sonë bregdetare",
        view_gallery: "Shiko Galerinë", explore_all: "Shfleto të gjitha",
        contact_us: "Na Kontaktoni", contact_sub: "Jemi këtu për t'ju ndihmuar të planifikoni qëndrimin tuaj të përsosur",
        your_name: "Emri juaj", your_email: "Email-i juaj", your_phone: "Telefoni juaj", your_message: "Mesazhi juaj",
        send_message: "Dërgo Mesazhin", send_success: "Faleminderit! Do t'ju kontaktojmë së shpejti.",
        send_error: "Pati një gabim. Provoni përsëri.", find_us: "Na Gjeni",
        rooms_intro: "Hapësira të rehatshme me dizajn modern dhe pamje nga deti",
        facilities_intro: "Përjetoni shërbimet tona të kuruara me kujdes",
        gallery_intro: "Eksploroni botën e Kompleksit Dea përmes imazheve",
        all: "Të gjitha", cat_rooms: "Dhomat", cat_beach: "Plazhi", cat_restaurant: "Restoranti", cat_hotel: "Hoteli", cat_videos: "Video",
        admin_login: "Hyrje Admin", username: "Përdoruesi", password: "Fjalëkalimi", login: "Hyr", logout: "Dil",
        dashboard: "Paneli", save: "Ruaj", delete: "Fshi", edit: "Modifiko", add_new: "Shto i ri",
        upload_image: "Ngarko foto", title: "Titulli", description: "Përshkrimi", price: "Çmimi", category: "Kategoria",
        loading: "Po ngarkohet...", cancel: "Anulo", confirm: "Konfirmo", rating: "Vlerësimi",
        messages: "Mesazhet", no_data: "Asnjë e dhënë",
        footer_rights: "Të gjitha të drejtat e rezervuara", footer_tagline: "Lukses bregdetar në Rivierën Shqiptare",
        hero_subtitle_default: "Përjetoni luksin bregdetar në Rivierën Shqiptare",
        message_book: "Përshëndetje! Dëshiroj të bëj një rezervim në Kompleksin Dea Radhimë.",
        message_room: "Përshëndetje! Jam i interesuar për dhomën:",
        hl_beach_distance: "Vetëm 30m nga plazhi", hl_private_beach: "Plazh privat me shezlongë",
        hl_family: "Resort i përshtatshëm për familje", hl_bar_restaurant: "Bar dhe restorant plazhi",
        faq_title: "Pyetjet më të shpeshta",
        faq_intro: "Gjeni përgjigjet për pyetjet më të zakonshme rreth qëndrimit tuaj te ne.",
        faq_more_questions: "Keni pyetje të tjera?",
        faq_more_questions_sub: "Jemi këtu për t'ju ndihmuar. Na shkruani në WhatsApp ose në formularin e kontaktit.",
    },
    en: {
        nav_home: "Home", nav_rooms: "Rooms", nav_facilities: "Facilities",
        nav_gallery: "Gallery", nav_contact: "Contact", nav_admin: "Admin", nav_faq: "FAQ", nav_blog: "Blog",
        book_now: "Book Now", whatsapp_book: "Book via WhatsApp",
        wifi: "Free Wi-Fi", restaurant: "Restaurant", bar: "Bar", beach: "Beach", parking: "Parking", market: "Market",
        featured_rooms: "Our Rooms", featured_rooms_sub: "Spaces designed for serenity and sea views",
        view_all_rooms: "View all rooms", from_price: "From", per_night: "/ night",
        explore_facilities: "Our Facilities", facilities_sub: "Everything you need for an unforgettable stay",
        reviews_title: "What Guests Say", reviews_sub: "Real experiences from our beloved guests",
        gallery_title: "Gallery", gallery_sub: "A glimpse into our coastal world",
        view_gallery: "View Gallery", explore_all: "Explore all",
        contact_us: "Contact Us", contact_sub: "We're here to help you plan your perfect stay",
        your_name: "Your name", your_email: "Your email", your_phone: "Your phone", your_message: "Your message",
        send_message: "Send Message", send_success: "Thank you! We'll get back to you soon.",
        send_error: "Something went wrong. Please try again.", find_us: "Find Us",
        rooms_intro: "Comfortable spaces with modern design and sea views",
        facilities_intro: "Experience our carefully curated amenities",
        gallery_intro: "Explore the world of Kompleksi Dea through images",
        all: "All", cat_rooms: "Rooms", cat_beach: "Beach", cat_restaurant: "Restaurant", cat_hotel: "Hotel", cat_videos: "Videos",
        admin_login: "Admin Login", username: "Username", password: "Password", login: "Login", logout: "Logout",
        dashboard: "Dashboard", save: "Save", delete: "Delete", edit: "Edit", add_new: "Add new",
        upload_image: "Upload image", title: "Title", description: "Description", price: "Price", category: "Category",
        loading: "Loading...", cancel: "Cancel", confirm: "Confirm", rating: "Rating",
        messages: "Messages", no_data: "No data",
        footer_rights: "All rights reserved", footer_tagline: "Coastal luxury on the Albanian Riviera",
        hero_subtitle_default: "Experience coastal luxury on the Albanian Riviera",
        message_book: "Hello! I would like to make a reservation at Kompleksi Dea Radhimë.",
        message_room: "Hello! I'm interested in the room:",
        hl_beach_distance: "Only 30m from the beach", hl_private_beach: "Private beach with sunbeds",
        hl_family: "Family-friendly resort", hl_bar_restaurant: "Beach bar & restaurant",
        faq_title: "Frequently Asked Questions",
        faq_intro: "Find answers to the most common questions about your stay with us.",
        faq_more_questions: "Have more questions?",
        faq_more_questions_sub: "We're here to help. Reach out via WhatsApp or our contact form.",
    },
    it: {
        nav_home: "Home", nav_rooms: "Camere", nav_facilities: "Servizi",
        nav_gallery: "Galleria", nav_contact: "Contatti", nav_admin: "Admin", nav_faq: "FAQ", nav_blog: "Blog",
        book_now: "Prenota Ora", whatsapp_book: "Prenota su WhatsApp",
        wifi: "Wi-Fi Gratis", restaurant: "Ristorante", bar: "Bar", beach: "Spiaggia", parking: "Parcheggio", market: "Market",
        featured_rooms: "Le Nostre Camere", featured_rooms_sub: "Spazi progettati per la serenità e la vista mare",
        view_all_rooms: "Vedi tutte le camere", from_price: "Da", per_night: "/ notte",
        explore_facilities: "I Nostri Servizi", facilities_sub: "Tutto ciò che serve per un soggiorno indimenticabile",
        reviews_title: "Cosa Dicono gli Ospiti", reviews_sub: "Esperienze reali dai nostri amati ospiti",
        gallery_title: "Galleria", gallery_sub: "Uno sguardo nel nostro mondo costiero",
        view_gallery: "Vedi Galleria", explore_all: "Esplora tutto",
        contact_us: "Contattaci", contact_sub: "Siamo qui per aiutarti a pianificare il tuo soggiorno perfetto",
        your_name: "Il tuo nome", your_email: "La tua email", your_phone: "Telefono", your_message: "Il tuo messaggio",
        send_message: "Invia Messaggio", send_success: "Grazie! Ti contatteremo presto.",
        send_error: "Si è verificato un errore. Riprova.", find_us: "Dove Siamo",
        rooms_intro: "Spazi confortevoli con design moderno e vista mare",
        facilities_intro: "Vivi i nostri servizi accuratamente curati",
        gallery_intro: "Esplora il mondo di Kompleksi Dea attraverso le immagini",
        all: "Tutti", cat_rooms: "Camere", cat_beach: "Spiaggia", cat_restaurant: "Ristorante", cat_hotel: "Hotel", cat_videos: "Video",
        admin_login: "Login Admin", username: "Utente", password: "Password", login: "Accedi", logout: "Esci",
        dashboard: "Pannello", save: "Salva", delete: "Elimina", edit: "Modifica", add_new: "Aggiungi",
        upload_image: "Carica foto", title: "Titolo", description: "Descrizione", price: "Prezzo", category: "Categoria",
        loading: "Caricamento...", cancel: "Annulla", confirm: "Conferma", rating: "Valutazione",
        messages: "Messaggi", no_data: "Nessun dato",
        footer_rights: "Tutti i diritti riservati", footer_tagline: "Lusso costiero sulla Riviera Albanese",
        hero_subtitle_default: "Vivi il lusso costiero sulla Riviera Albanese",
        message_book: "Ciao! Vorrei effettuare una prenotazione presso Kompleksi Dea Radhimë.",
        message_room: "Ciao! Sono interessato alla camera:",
        hl_beach_distance: "Solo 30m dalla spiaggia", hl_private_beach: "Spiaggia privata con lettini",
        hl_family: "Resort per famiglie", hl_bar_restaurant: "Bar e ristorante in spiaggia",
        faq_title: "Domande Frequenti",
        faq_intro: "Trova le risposte alle domande più comuni sul tuo soggiorno da noi.",
        faq_more_questions: "Hai altre domande?",
        faq_more_questions_sub: "Siamo qui per aiutarti. Contattaci su WhatsApp o tramite il modulo.",
    },
    de: {
        nav_home: "Startseite", nav_rooms: "Zimmer", nav_facilities: "Einrichtungen",
        nav_gallery: "Galerie", nav_contact: "Kontakt", nav_admin: "Admin", nav_faq: "FAQ", nav_blog: "Blog",
        book_now: "Jetzt Buchen", whatsapp_book: "Buchen über WhatsApp",
        wifi: "Gratis WLAN", restaurant: "Restaurant", bar: "Bar", beach: "Strand", parking: "Parkplatz", market: "Markt",
        featured_rooms: "Unsere Zimmer", featured_rooms_sub: "Räume gestaltet für Ruhe und Meerblick",
        view_all_rooms: "Alle Zimmer ansehen", from_price: "Ab", per_night: "/ Nacht",
        explore_facilities: "Unsere Einrichtungen", facilities_sub: "Alles für einen unvergesslichen Aufenthalt",
        reviews_title: "Was Gäste Sagen", reviews_sub: "Echte Erfahrungen unserer geliebten Gäste",
        gallery_title: "Galerie", gallery_sub: "Ein Blick in unsere Küstenwelt",
        view_gallery: "Galerie ansehen", explore_all: "Alles entdecken",
        contact_us: "Kontaktieren Sie Uns", contact_sub: "Wir helfen Ihnen bei der Planung Ihres perfekten Aufenthalts",
        your_name: "Ihr Name", your_email: "Ihre E-Mail", your_phone: "Telefon", your_message: "Ihre Nachricht",
        send_message: "Nachricht senden", send_success: "Danke! Wir melden uns bald.",
        send_error: "Etwas ist schief gelaufen. Bitte erneut versuchen.", find_us: "Finden Sie Uns",
        rooms_intro: "Komfortable Räume mit modernem Design und Meerblick",
        facilities_intro: "Erleben Sie unsere sorgfältig kuratierten Annehmlichkeiten",
        gallery_intro: "Entdecken Sie die Welt von Kompleksi Dea in Bildern",
        all: "Alle", cat_rooms: "Zimmer", cat_beach: "Strand", cat_restaurant: "Restaurant", cat_hotel: "Hotel", cat_videos: "Videos",
        admin_login: "Admin Login", username: "Benutzer", password: "Passwort", login: "Anmelden", logout: "Abmelden",
        dashboard: "Dashboard", save: "Speichern", delete: "Löschen", edit: "Bearbeiten", add_new: "Hinzufügen",
        upload_image: "Bild hochladen", title: "Titel", description: "Beschreibung", price: "Preis", category: "Kategorie",
        loading: "Lädt...", cancel: "Abbrechen", confirm: "Bestätigen", rating: "Bewertung",
        messages: "Nachrichten", no_data: "Keine Daten",
        footer_rights: "Alle Rechte vorbehalten", footer_tagline: "Küstenluxus an der Albanischen Riviera",
        hero_subtitle_default: "Erleben Sie Küstenluxus an der Albanischen Riviera",
        message_book: "Hallo! Ich möchte eine Reservierung im Kompleksi Dea Radhimë vornehmen.",
        message_room: "Hallo! Ich interessiere mich für das Zimmer:",
        hl_beach_distance: "Nur 30m vom Strand", hl_private_beach: "Privatstrand mit Liegen",
        hl_family: "Familienfreundliches Resort", hl_bar_restaurant: "Strandbar & Restaurant",
        faq_title: "Häufig gestellte Fragen",
        faq_intro: "Finden Sie Antworten auf die häufigsten Fragen zu Ihrem Aufenthalt.",
        faq_more_questions: "Weitere Fragen?",
        faq_more_questions_sub: "Wir sind da, um zu helfen. Kontaktieren Sie uns über WhatsApp oder das Formular.",
    },
};

export function LanguageProvider({ children }) {
    const [lang, setLangState] = useState(
        () => localStorage.getItem("dea_lang") || "al"
    );

    useEffect(() => {
        localStorage.setItem("dea_lang", lang);
        document.documentElement.lang = lang;
    }, [lang]);

    const setLang = (l) => setLangState(l);
    const t = (key) =>
        baseStrings[lang]?.[key] ?? baseStrings.en[key] ?? key;

    return (
        <LanguageContext.Provider value={{ lang, setLang, t }}>
            {children}
        </LanguageContext.Provider>
    );
}

export const useLang = () => useContext(LanguageContext);

export function tField(obj, field, lang) {
    if (!obj) return "";
    return (
        obj[`${field}_${lang}`] ||
        obj[`${field}_en`] ||
        obj[`${field}_al`] ||
        obj[field] ||
        ""
    );
}
